import { CodPaisCellRenderer } from "../../../../../shared/components/CustomCells/CodPaisCellRenderer";
import { ColumnsFactory } from "../../../../../shared/components/Grid/functions";

export const getColumnDefs = () => {

  return [
    ColumnsFactory.TextColumn("Tipo", "tipo"),
    ColumnsFactory.TextColumn("Cod. Sociedad", "idSociedad"),
    ColumnsFactory.TextColumn("Sociedad", "sociedad"),
    ColumnsFactory.TextColumn("Cif", "cif"),
    ColumnsFactory.TextColumn("Cod. Pais", "codPais", {cellRendererFramework: CodPaisCellRenderer}),
    ColumnsFactory.TextColumn("Pais", "pais"),
    ColumnsFactory.DateColumn("Fecha Baja", "fechaBaja"),
    ColumnsFactory.TextColumn("Referencia", "referencia"),
    ColumnsFactory.BooleanColumn("Fact/Cert", "facturacion_Certificado")
  ];
};
